import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import Label from '../../../transactions/[id]/TransactionData/Label'
import Value from '../../../transactions/[id]/TransactionData/Value'
import { buildAppCustomerPath } from '../../../../../pages/app/customers/[id]'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import { customerProxy } from '../../../../../shared/proxies/customerProxy'

export function CustomerDetailsSection (): ReactElement {
  const { siteTheme: { breadcrumbs: breadCrumbTheme } } = useSnapshot(proxyGlobalAuth)
  const snap = useSnapshot(customerProxy)

  return (
    <div className="grid grid-cols-4 border-b border-wpy-light-blue-700 my-4">
      <Label text="Company Name" additionalClasses="border-l" />
      <Value>
        {snap.customer?.companyName}
      </Value>
      <Label text="Parent Company" additionalClasses="border-l" />
      <Value>
        <a className={breadCrumbTheme.classes} href={buildAppCustomerPath(snap.currentParentCustomer?.id || '')}>
          {snap.currentParentCustomer?.companyName}
        </a>
      </Value>
      <Label text="First Name" additionalClasses="border-l" />
      <Value>
        {snap.customer?.firstName}
      </Value>
      <Label text="Last Name" />
      <Value>
        {snap.customer?.lastName}
      </Value>
      <Label text="Email Address" additionalClasses="border-l" />
      <Value additionalClasses="col-span-3">
        {snap.customer?.email}
      </Value>
      <Label text="Street Address" additionalClasses="border-l" />
      <Value additionalClasses="col-span-3">
        {snap.customer?.addressOne}
      </Value>
      <Label text="City" additionalClasses="border-l" />
      <Value additionalClasses="col-span-3">
        {snap.customer?.city}
      </Value>
      <Label text="State" additionalClasses="border-l" />
      <Value>
        {snap.customer?.state}
      </Value>
      <Label text="Zip/Postal Code" />
      <Value>
        {snap.customer?.postalCode}
      </Value>
      <Label text="Child Companies" />
      <Value additionalClasses="col-span-3">
        {snap.childCompanies?.map((company, idx) => {
          return (
            <a key={idx} className={cn(breadCrumbTheme.classes, 'underline')} href={buildAppCustomerPath(company.id || '')}>
              {company.companyName ?? ` ${company.firstName} ${company.lastName} `}
            </a>
          )
        })}
      </Value>
    </div>
  )
}
